import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { ProductAttributes } from "../../recommendation.types";
import { requestRevertProductAttributes } from "./revertProductAttributes.request";

const useRevertProductAttributes = (
  options?: MutationOptions<
    ProductAttributes | null,
    ApiServiceError<ApiError>,
    { id: string; fields?: string[] }
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestRevertProductAttributes,
    ...options,
    // A revert that could not re-enrich has still released the fields, so the
    // detail is stale either way.
    onSettled: (data, error, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "enrichment"]
      });
      options?.onSettled?.(data, error, variables, ctx);
    }
  });
};

export default useRevertProductAttributes;
